import { gql } from "@apollo/client";

import { scenarioVersionWithRulesFragment } from "src/graphql/anti-fraud/fragments/ScenarioVersionFragment";

export const shortScenarioFragment = gql`
  fragment ShortScenarioFragment on Scenario {
    id
    name
    code
    description
    caseType {
      code
      name
    }
    adminStatus {
      ...AdminStatus
    }
    hasDraftVersion
    activeVersion {
      ...ScenarioVersionWithRulesFragment
    }
  }

  ${scenarioVersionWithRulesFragment}
`;
